import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DriverNav from "./DriverNav";
import "../../styles/tcDash.css";
import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
export default function UpdateCase() {
  const navigate = useNavigate();

  useEffect(() => {
    getCase();
  }, []);

  const [formData, setFormData] = useState({
    caseID: "",
    licenseNo: "",
    date: "",
    violated: "",
    fines: "",
    location: "",
    status: "",
    request: "",
  });

  const params = useParams();

  const getCase = async () => {
    try {
      let response = await fetch(`http://localhost:8000/hist/${params.key}`);
      response = await response.json();
      // Check if the response is an array
    const caseData = Array.isArray(response) ? response[0] : response;

    setFormData(caseData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.warn(typeof formData)
    let result = await fetch(`http://localhost:8000/hist/${params.key}`, {
            method: 'Put',
            body: JSON.stringify(formData),
            headers: {
                'Content-Type': 'Application/json'
            }
        });
        result = await result.json();
        
        if (result) {
          toast.success("Update Request Sent!", {
            position: "top-left",
            autoClose: 2000,
            theme: "dark",
          });
  
            navigate('/driver/dashboard')
        }
  };

  return (
    <div>
      <header>
        <DriverNav />
      </header>
      <main>
        {/* Cases */}
        <section className="searches">
          <div className="container mt-5 pt-1">
            <div className="row">
              <div className="col-12 col-sm-7 col-md-6 m-auto">
                <div className="card border-0 shadow custom-card">
                  <div className="card-body p-4  text-light">
                    {/* User Icon */}
                    <div className="d-flex justify-content-center mt-4 mb-4">
                      <i className="fa-solid fa-user"></i>
                    </div>

                    {/* Input fields for user information */}

                    <form onSubmit={handleSubmit}>
                      
                      <select
                        className="form-select mt-2"
                        aria-label="Default select example"
                        name="request"
                        value={formData.request}
                        onChange={handleChange}
                      >
                        <option selected>Request for Changes</option>
                        <option value="yes">Wrong Case Added</option>
                        <option value="payment-done">Payment Done but Not Showing</option>
                      </select>

                      <div className="text-center mt-4">
                        <button
                          type="submit"
                          className="btn btn-outline-light w-100"
                        >
                          Update
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main><ToastContainer />
    </div>
  );
}
